import * as React from "react";
import FormField from "components/FormField/FormField";
import { FieldWrapper } from "components/WorkItem/Form/Field/Field.styles";
import { FieldsWrapper, VehicleSectionWrapper } from "components/WorkItem/Form/Section.styles";
import { Header, DarkText } from "components/WorkItem/Form/Vehicle/Section.styles";

const Pre1981Data = ({
    onSetPre1981DataValue,
    pre1981Data
}) => {
    const handleChange = (value, item) => {
        try {
            pre1981Data.map(b => {
                if (b.sequence === item.id) {
                    b.value = value;
                }
            });
        }
        catch (ex) { }

        onSetPre1981DataValue(pre1981Data);

    }

    
    let formFieldsWrapper = [];
    let formFields = [];

    try {
        pre1981Data.map((field, index) => {
                formFields.push(<FieldWrapper key={field.sequence}>
                    <FormField
                        key={field.sequence}
                        id={field.sequence}
                        title={field.helpText}
                        item={field}
                        items={field.validValues.value.split("|")}
                        placeholder={field.helpText}
                        value={field.value}
                        isRequired={true}
                        onChange={handleChange}
                        disabled={false}
                        groupField={field.groupField}
                        fieldType={field.type}
                    />
                </FieldWrapper>);
        }
        );

        formFieldsWrapper.push(
            <FieldsWrapper key={`fieldsWrapper${1}`}>
                {formFields}
            </FieldsWrapper>);
    }
    catch (ex) {console.log(ex) }

    return (
        <div>
            <VehicleSectionWrapper>
                <Header>
                    <DarkText>Vehicle Information</DarkText>
                </Header>
            </VehicleSectionWrapper>
            {formFieldsWrapper}
        </div>
    );
}

export default Pre1981Data;